import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Banners from '../../../../components/elements/Banners';
import { getAsync } from '../../../../components/helper/axiosHelper';
import { PageHitCountApi } from '../../../../shared/Helper';
import { useLocation } from 'react-use';

const InfographicDetail = () => {
  const [apiData, setApiData] = useState([]);
  const { id } = useParams();
  const { t } = useTranslation();
  const isActive = useSelector((state) => state.toggle.isActive);
  const { pathname } = useLocation();

  useEffect(() => {
    PageHitCountApi(pathname, 0);
  }, []);




  const getData = async () => {
    await getAsync('CMSInfographic/GetByIdCMSInfographic/', { id: id })
      .then((response) => {
        const result = response?.data[0];
        setApiData(result);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    localStorage.setItem('isHome', true);
    getData();
  }, []);

  return (
    <>
      {/* <div className="col-lg-12">
        <div className="header-wrapper" style={{ textAlign: 'center' }}>
          <h1>Infographic Detail</h1>
        </div>
        <div style={{ margin: '20px', padding: '20px' }} className="col-lg-10">
          {apiData?.map((item, index) => (
            <div key={item.title + index}>
              <div className="wrapper">
                <img
                  style={{
                    borderRadius: '20px',
                    border: '1px solid black',
                    height: '500px',
                    width: '600px'
                  }}
                  src={`data:image/jpeg;base64,${item?.doc}`}
                  alt="img.jpg"
                />
              </div>
              <div className="content-title">
                <h2>{item?.title}</h2>
                <a href={item?.link} target="_blank" rel="noopener noreferrer">
                  {item?.link}
                </a>
                <p>{item?.publicationDate}</p>
                <p>{item?.content}</p>
              </div>
              <div className="content">
                <pre>{item?.newsPlace ? item?.newsPlace : 'N/A'}</pre>
              </div>
            </div>
          ))}
        </div>
      </div> */}

      <div className="">
        <Banners />

        <section className={ `h-90 pb-48 px-20 mt-28 ${isActive ? 'text-right' : 'text-left'}` }>
          <img src={ `data:image/jpeg;base64,${apiData?.doc}` } className="lg:w-1/2 rounded-3xl" alt="" />
          <h2 className="text-base mt-4 font-bold ">{ isActive ? apiData?.date : apiData?.date }</h2>
          <h2 className="text-black text-4xl font-bold py-6">{ isActive ? apiData?.title : apiData?.titleEn }</h2>
          <h4 className="text-black text-2xl pt-6">{ isActive ? apiData?.content : apiData?.contentEn }</h4>

        </section>

      </div>
    </>
  );
};

export default InfographicDetail;
